import React from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion'
import Img from 'gatsby-image'
import tinycolor from 'tinycolor2'

import Menu from '../Menu'
import logo from '../../../assets/images/HTSLogo2.svg'
import menuClose from '../../../assets/images/icon-menu-close.svg'
import menu from '../../../assets/images/icon-menu.svg'

const HeaderContainer = styled.header`
  position: relative;
  font-family: ${props => props.theme.headerFont};
  background: ${props => props.theme.white};

  & > div:first-child {
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    margin: 0 auto;

    position: 'relative';

    & > a {
      line-height: 1;
      color: ${props => props.theme.textColor};

      &:hover {
        color: ${props => props.theme.primary};
      }
    }

    @media (min-width: 768px) {
      padding: 10px 60px;
    }
  }

  & > div:nth-child(2) {
    text-align: center;
  }
`

const Logo = styled.img`
  font-family: ${props => props.theme.headerFont};
  margin-bottom: 0;
  font-size: 20px;
  width: 175px;

  @media (min-width: 768px) {
    font-size: 20px;
  }
`

const MenuButton = styled.button`
  background: transparent;
  border-color: transparent;
  padding: 0;

  &:focus {
    outline: none;
  }

  & img {
    margin: 0;
    margin-right: ${props => (props.visible ? '5px' : '0')};
  }
`
class Header extends React.Component {
  state = {
    mobile: false,
    menuVisible: false,
  }

  resizeHandler = () => {
    if (window) this.setState({ mobile: window.innerWidth < 768 })
  }

  componentDidMount() {
    this.resizeHandler()
    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  toggleMenu = () => {
    if (window.innerWidth < 768) {
      this.setState(prevState => ({ menuVisible: !prevState.menuVisible }))
    }
  }

  render() {
    return (
      <HeaderContainer
        mobile={this.state.mobile}
        {...this.props}
        menuVisible={this.state.menuVisible}
      >
        <div>
          <Link
            to="/"
            css={{
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Logo src={logo} alt="Hardin Therapeutic Services" />
            <span className="sr-only">Hardin Therapeutic Services</span>
          </Link>

          {this.state.mobile ? (
            <MenuButton
              onClick={this.toggleMenu}
              visible={this.state.menuVisible}
              aria-label={this.state.menuVisible ? 'Close Menu' : 'Open Menu'}
            >
              <img
                src={this.state.menuVisible ? menuClose : menu}
                alt={this.state.menuVisible ? 'Close Menu' : 'Open Menu'}
              />
              <span className="sr-only">
                {this.state.menuVisible ? 'Close Menu' : 'Open Menu'}
              </span>
            </MenuButton>
          ) : null}

          <Menu mobile={this.state.mobile} visible={this.state.menuVisible}>
            <ul>
              <li>
                <Link to="/about" onClick={this.toggleMenu}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" onClick={this.toggleMenu}>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={this.toggleMenu}>
                  Contact
                </Link>
              </li>
            </ul>
          </Menu>
        </div>
      </HeaderContainer>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Common/Header/index.js